import { rankings } from '@/mocks/baoliao';

const tagColors: Record<string, string> = {
  '独家': 'bg-primary-100 text-primary-700',
  '猛料': 'bg-accent-100 text-accent-700',
  '实时': 'bg-secondary-100 text-secondary-700',
  '追踪': 'bg-primary-100 text-primary-700',
  '突发': 'bg-accent-100 text-accent-700',
};

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-secondary-500',
  new: 'ri-add-line text-accent-500',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热议榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时更新全网最火爆的爆料话题排名
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-md font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className={`text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                  {item.tag}
                </span>
                <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">{item.heat}</span>
                <span className={`w-5 h-5 flex items-center justify-center ${changeIcons[item.change]}`}>
                  <i className={changeIcons[item.change]}></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}